export interface ScrollMarginInput {
    targetTop: number;
    rootTop: number;
    rootClientTop: number;
    rootScrollTop: number;
}

/** Elements laid out before `target` inside `root`: preceding siblings at every level up to root, in document order. */
export const getPrecedingElements = (target: Element, root: Element): Element[] => {
    if (target === root || !root.contains(target)) return [];
    const levels: Element[][] = [];
    let node: Element | null = target;
    while (node && node !== root) {
        const siblings: Element[] = [];
        let prev = node.previousElementSibling;
        while (prev) {
            siblings.unshift(prev);
            prev = prev.previousElementSibling;
        }
        levels.unshift(siblings);
        node = node.parentElement;
    }
    return levels.flat();
};

/** Offset of the list's top from the start of the scroll content, independent of the current scroll position. */
export const computeScrollMargin = ({
    targetTop,
    rootTop,
    rootClientTop,
    rootScrollTop,
}: ScrollMarginInput): number => Math.round(targetTop - rootTop - rootClientTop + rootScrollTop);
